import React, { useRef, useState } from 'react';

interface ChatInputProps {
  onSend: (text: string) => void;
  disabled?: boolean;
  disabledReason?: string;
}

function autoResize(el: HTMLTextAreaElement) {
  el.style.height = 'auto';
  el.style.height = `${el.scrollHeight}px`;
}

export const ChatInput: React.FC<ChatInputProps> = ({ onSend, disabled, disabledReason }) => {
  const [value, setValue] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
    }
    setTimeout(() => textareaRef.current?.focus(), 0);
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
    autoResize(e.target);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const isActive = !!value.trim() && !disabled;

  return (
    <div className="chat-input-inner">
      <textarea
        ref={textareaRef}
        className="chat-input-inner__textarea"
        placeholder={disabledReason ?? 'Message…'}
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        rows={1}
        aria-label="Message input"
        disabled={!!disabledReason && !value}
      />
      <button
        className={`chat-input-inner__send${isActive ? ' chat-input-inner__send--active' : ''}`}
        onClick={handleSend}
        disabled={!isActive}
        aria-label="Send message"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 13V3M8 3L3.5 7.5M8 3L12.5 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
};
